import styled from "styled-components";

export const RibbonWrapper = styled.div`
  width: 140px;
  height: 150px;
  overflow: hidden;
  position: absolute;

  /* positioning the ribbon to top right */
  top: -5px;
  right: 5px;
  ::before,
  ::after {
    position: absolute;
    z-index: -1;
    content: "";
    display: block;
    border: 5px solid #2980b9;
    border-top-color: transparent;
    border-right-color: transparent;
  }
  ::before {
    top: 0;
    left: 0;
  }
  ::after {
    bottom: 0;
    right: 0;
  }
`;

export const RibbonContent = styled.span`
  position: absolute;
  display: block;
  width: 225px;
  padding: 5px 0;
  background-color: #1070b6;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  color: #fdd440;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.35px;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  text-transform: uppercase;
  text-align: center;

  /* positioning the ribbon to top right */
  left: 3px;
  top: 15px;
  transform: rotate(45deg);
`;
